// extracted by mini-css-extract-plugin
export default {"prefix":"styles_prefix__52FKr","readOnlyParentLabel":"styles_readOnlyParentLabel__iJcNm"};